'use strict';
import Helpers from '../_helpers';
/**
 * Wistia Class
 *
 * @type class
 */
export default class Wistia {
    /**
     * Constructor
     *
     * @param Config_Interface
     */
    constructor(config) {
        /**
         * Helper
         *
         * @type Helpers
         */
        this.helpers = new Helpers;
        this._config = config;
    }
    init(video_id) {
        let _self = this;
        if (!window._wq)
            window._wq = [];
        window._wq.push({
            id: video_id,
            onReady(video) {
                _self._video = video;
                let _played = false;
                video.bind("play", function () {
                    if (!_played && _self._onStart) {
                        _played = true;
                        _self._onStart(video);
                    }
                });
                video.bind('percentwatchedchanged', function (percent, lastPercent) {
                    if (_self._onProgress) {
                        _self._onProgress(video, percent, lastPercent);
                    }
                });
                video.bind("end", function () {
                    if (_self._onEnd) {
                        _self._onEnd(video);
                    }
                });
            },
        });
    }
    start(dataLayer) {
        let _self = this;
        this._onStart = function (video) {
            let custom_model = {
                event: '',
                title: video.name(),
                url: '',
                id: video.hashedId(),
                provider: '',
            };
            window.dataLayer.push(_self.helpers.process_datalayer(dataLayer, { video: custom_model }));
        };
    }
    progress(percentages, dataLayer) {
        let _self = this;
        let percentagesMet = [];
        this._onProgress = function (video, percent, lastPercent) {
            let custom_model = {
                event: '',
                progress: '',
                title: video.name(),
                url: '',
                id: video.hashedId(),
                provider: '',
            };
            for (var percentage of percentages) {
                if (percent >= percentage && percentagesMet.indexOf(percentage) === -1) {
                    percentagesMet.push(percentage);
                    custom_model.progress = (percentage * 100).toString() + '%';
                    window.dataLayer.push(_self.helpers.process_datalayer(dataLayer, { video: custom_model }));
                }
            }
        };
    }
    end(dataLayer) {
        let _self = this;
        this._onEnd = function (video) {
            let custom_model = {
                event: '',
                progress: '100%',
                title: video.name(),
                url: '',
                id: video.hashedId(),
                provider: '',
            };
            window.dataLayer.push(_self.helpers.process_datalayer(dataLayer, { video: custom_model }));
        };
    }
}
